<template>
  <div>
    <div>
      <nx-search ref="searchForm" :source="searchForm" :config="searchConfig">
        <template slot="double-select">
          <double-select :reset-key="searchForm.vin"></double-select>
        </template>
        <div slot="search">
          <el-button type="primary" @click="$refs.nxTable.search(1)">{{ "查询" }}</el-button>
          <el-button @click="reset()">{{ "重置" }}</el-button>
        </div>
      </nx-search>
    </div>

    <div>
      <nx-table ref="nxTable" :data="tableData" table-title="诊断记录" @search="search">
        <el-table-column label="VIN" prop="vin" ></el-table-column>
        <el-table-column label="ICCID" prop="iccid" > </el-table-column>
        <el-table-column label="消息流水号" prop="startTime" >
          <template slot-scope="{ row }">
            <el-button type="text" @click="checkSeralDetail(row)">
              {{ row.serialNo || '' }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="指令下发时间" prop="responseTime" >
          <template slot-scope="{ row }">
            {{ $utils.formatDate(row.responseTime) }}
          </template>
        </el-table-column>
        <el-table-column label="终端响应情况" prop="responseResult" >
           <template v-slot="{ row }">
            {{ (responseResultsTypes.find((item) => item.value === row.responseResult) || {}).label}}
          </template>
        </el-table-column>
        <el-table-column label="CAN数据采集时间" prop="responseTime" >
          <template slot-scope="{ row }">
            {{ $utils.formatDate(row.responseTime) }}
          </template>
        </el-table-column>

        <el-table-column label="指令类型" prop="commandType" >
          <template v-slot="{ row }">
            {{ (udsConmondTypes.find((item) => item.value === row.commandType) || {}).label }}
          </template>
        </el-table-column>
        <el-table-column label="请求CAN_ID" prop="requestCanId" />
        <el-table-column label="诊断结果" prop="udsResult" >
          <template v-slot="{ row }">
            {{ (responseResultsTypes.find((item) => item.value === row.udsResult) || {}).label }}
          </template>
        </el-table-column>

        <el-table-column label="结果详情" prop="udsResult" >
          <template v-slot="{ row }">
            <el-button type="text" v-if="row.udsResult == 1 && row.commandType != 1" @click="showRightList(row)">
              {{ '查看详情' }}
            </el-button>
            <div v-if="row.udsResult != 1">
              {{ row.resultDesc }}
            </div>
            <div v-else>{{ '' }}</div>
          </template>
        </el-table-column>
      </nx-table>
    </div>
    <result-dialog :id="resultDialogConfig.id" :visible.sync="resultDialogConfig.show" :seri-no="resultDialogConfig.serialNo"></result-dialog>
    <deail-dialog
      :id="detailDialogConfig.id"
      :visible.sync="detailDialogConfig.show"
      :itemDic="detailDialogConfig.itemDic"
      :type="detailDialogConfig.type"
      :title="detailDialogConfig.title"
    ></deail-dialog>
  </div>
</template>

<script>
import {
  fileStatusArr,
  powerTypes,
  responseResultsTypes,
  udsConmondTypes,
  // vehiclePurposeTypes
} from '../../config.js';


import { getUdsCheckList, exportUdsItemList } from '@/api/dataService/udsV2.js';
import doubleSelect from '@/components/doubleSelect/index.vue';
import ResultDialog from '../component/resultDialog.vue';
import DeailDialog from '../component/deailDialog.vue';

export default {
  components: { doubleSelect, ResultDialog, DeailDialog },
  name: '',

  data() {
    return {
     
      responseResultsTypes,
      udsConmondTypes,
      

      searchForm: {
        resetKey: 'vin',
        selectValue: '',
        selectKey: 'vin',
        vin: '', // 动态搜索
        responseResult: '',
        commandType: '', // 指令类型
        udsResult: '', //诊断结果
        canId: '',
      },
      tableData: [], //主页面数据
      resultDialogConfig: {
        id: '',
        show: false,
        serialNo: '',
      },
      detailDialogConfig: {
        id: '',
        show: false,
        type: '',
        itemDic: {},
        title: '',
      },
    };
  },
  computed: {
    searchConfig() {
      return [
        {
          key: 'selectKey',
          secKey: 'selectValue',
          thidKey: 'resetKey',
          component: 'el-double-select',
          span: 8,
          label: `VIN`, //文件状态
          labelWidth: 'auto',
          props: {
            placeholder: '请输入vin',
            clearable: true,
          },
        },
        {
          key: 'responseResult',
          component: 'el-select',
          span: 8,
          label: `终端响应情况:`, //配置名称
          labelWidth: 'auto',
          data: [
            {
              value: '0',
              label: '未响应',
            },
            {
              value: '1',
              label: '成功',
            },
            {
              value: '2',
              label: '失败',
            },
          ],
          props: {
            placeholder: '请选择',
            clearable: true,
          },
        },
        {
          key: 'commandType',
          component: 'el-select',
          span: 8,
          label: `指令类型:`, //指令类型
          labelWidth: 'auto',
          data: [
            {
              value: '1',
              label: '清除故障',
            },
            {
              value: '2',
              label: '读取故障',
            },
            {
              value: '3',
              label: '读取did',
            },
          ],
          props: {
            placeholder: '请选择',
            clearable: true,
          },
        },
        {
          key: 'udsResult',
          component: 'el-select',
          span: 8,
          label: `诊断结果:`, //诊断结果
          labelWidth: 'auto',
          data: [
            {
              value: '1',
              label: '成功',
            },
            {
              value: '2',
              label: '失败',
            },
          ],
          props: {
            placeholder: '请选择',
            clearable: true,
          },
        },
        {
          key: 'canId',
          component: 'el-input',
          span: 8,
          label: `请求CAN_ID:`, //请求CAN_ID
          labelWidth: 'auto',
          props: {
            placeholder: '请输入',
            clearable: true,
          },
        },
        {
          component: 'slot',
          slotName: 'search',
          span: 8,
        },
      ];
    },
  },
  methods: {
    reset() {
      this.$refs.searchForm.resetFields();
      (this.searchForm.resetKey = 'vin'), (this.searchForm.selectKey = 'vin');
      this.searchForm.selectValue = '';
    },
    checkSeralDetail(row) {
      this.resultDialogConfig.id = row.udsTaskId;
      this.resultDialogConfig.show = true;
      this.resultDialogConfig.serialNo = row.serialNo;
    }, //检查消息流水号弹框
    showRightList(row) {
      let realMap = { ...row, realTime: this.$utils.formatDate(row.responseTime) };
      this.detailDialogConfig.id = row.id;
      this.detailDialogConfig.type = row.commandType == 2 ? '1' : '2';
      this.detailDialogConfig.itemDic = { ...realMap };
      this.detailDialogConfig.title =  row.commandType == 2 ? '读取故障结果详情' : '读取DID结果详情';
      this.detailDialogConfig.show = true;
    }, // 读取故障结果详情
    async search(pagination) {
      const { pageNum, pageSize } = pagination;
      let params = {};
      if (this.searchForm.selectKey === 'vin') {
        let selectVIN = this.searchForm.selectValue ?? '';
        params = {
          ...this.searchForm,
          pageNum,
          pageSize,
          vin : selectVIN,
        };
      } else if (this.searchForm.selectKey === 'iccid') {
        let iccid = this.searchForm.selectValue ?? '';
        params = {
          ...this.searchForm,
          pageNum,
          pageSize,
          iccid,
        };
      } else {
        let sn = this.searchForm.selectValue ?? '';
        params = {
          ...this.searchForm,
          pageNum,
          pageSize,
          sn,
        };
      }
      delete params.selectKey;
      delete params.selectValue;
      delete params.resetKey;

      const { data } = await getUdsCheckList(params);
      this.tableData = data.list;
      pagination.total = data.total;
    },
  },
};
</script>
